// React
import React from 'react';
import { Controller } from 'react-hook-form';
// Material-UI
import TextField from '@mui/material/TextField';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEReferenceReadingArray from './components/PEReferenceReadingArray';

const PEReferenceReading = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir, section } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Reading Material" instructions="Select the page for the reading material." />
      <Controller
        control={control}
        name="content.material"
        render={({ field }) => (
          <TextField
            className="mt-16"
            {...field}
            label="Reading Material"
            placeholder="Reading Material"
            id="Reading Material"
            error={!!errors.content?.material}
            helperText={errors.content?.material?.message}
            variant="outlined"
            fullWidth
            required
          />
        )}
      />

      <NumberedHeading number="2" title="Questions" instructions="Using the controls below, add the questions for the referenced reading." />
      <Controller 
        control={control}
        name="content.core"
        render={({ field }) => <PEReferenceReadingArray inputDir={inputDir} {...{control, errors }} />}
      />
    </div>
  )
}

export default PEReferenceReading;